var EditorComponent = new JS.Class({
  initialize: function() {
    this.editor = null;
  },

  setEditor: function(editor) {
    this.editor = editor;
  },

  saveComponent: function(init, success, error) {
    this.editor.saveComponent(this, init, success, error);
  },

  onSaveSuccess: function(result) {},

  onSaveError: function(error) {},
});
